// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"style_checkboxContainer__INi57","check":"style_check__8eAzE"};